/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'move': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M5.96.002a.364.364 0 0 0-.216.103L4.108 1.74a.364.364 0 1 0 .511.517L5.636 1.24v4.398H1.24l1.017-1.017a.364.364 0 1 0-.512-.517L.108 5.74a.364.364 0 0 0 0 .517l1.636 1.636a.364.364 0 1 0 .512-.517L1.239 6.366h4.397v4.392L4.62 9.741a.364.364 0 1 0-.511.517l1.636 1.636c.142.14.37.14.512 0l1.636-1.636a.364.364 0 1 0-.511-.517l-1.017 1.017V6.366h4.397L9.744 7.377a.364.364 0 1 0 .512.517l1.636-1.636a.364.364 0 0 0 0-.517l-1.636-1.636a.364.364 0 1 0-.512.517l1.017 1.017H6.364V1.24L7.38 2.258a.364.364 0 1 0 .511-.517L6.256.105A.364.364 0 0 0 5.96.002z" _fill="#404040" fill-rule="nonzero"/>'
  }
})
